module.exports = __webpack_public_path__ + "static/media/game.efc07779.svg";